import { copy, IPromise, IScope } from "angular";
import { StateService } from "@uirouter/angularjs";
import { IBadge } from "../models/badges";
import { BadgeService } from "../services/badges";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import colors from "wwwroot/json/colors.json";
import icons from "wwwroot/json/icons-badges.json";
import patterns from "wwwroot/json/patterns.json";
import { IStateInit } from "@gtmhub/core/routing";

interface IBadgeFormParams {
  badgeId: string;
}

interface IBadgeFormScope extends IScope {
  badge: IBadge;
  indicators: {
    loading: boolean;
    saving: boolean;
  };
  isEdit: boolean;
  isEdited: boolean;
  patterns: string[];
  colors: string[];
  icons: string[];
  save();
}

export class BadgeFormCtrl implements IStateInit {
  public static $inject = ["$scope", "$state", "$stateParams", "BadgeService", "UIErrorHandlingService"];
  private originalBadge: IBadge;
  constructor(
    private $scope: IBadgeFormScope,
    private $state: StateService,
    private $stateParams: IBadgeFormParams,
    private badgeService: BadgeService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.$scope.indicators = {
      loading: false,
      saving: false,
    };
    this.$scope.colors = colors.badgesColors;
    this.$scope.icons = icons;
    this.$scope.patterns = patterns;

    this.$scope.save = this.save;
  }

  public stateInit(): IPromise<unknown> {
    return this.init();
  }

  private init = (): IPromise<unknown> => {
    if (this.$stateParams.badgeId) {
      this.$scope.isEdit = true;
      this.$scope.isEdited = false;
      this.$scope.indicators.loading = true;

      return this.badgeService.getBadge(this.$stateParams.badgeId).then(
        (badge) => {
          this.$scope.indicators.loading = false;
          this.$scope.badge = badge;
          this.originalBadge = copy(badge);

          this.$scope.$watchGroup(["badge.name", "badge.icon", "badge.background", "badge.pattern"], (badgeProperties) => {
            this.$scope.isEdited =
              this.originalBadge.name !== badgeProperties[0] ||
              this.originalBadge.icon !== badgeProperties[1] ||
              this.originalBadge.background !== badgeProperties[2] ||
              this.originalBadge.pattern !== badgeProperties[3];
          });
        },
        (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "loading" })
      );
    } else {
      this.$scope.badge = {
        background: "#417aea",
        icon: "food_crab",
        pattern: "chevron",
        name: "",
      };
    }
  };

  private save = () => {
    this.$scope.indicators.saving = true;
    if (this.$scope.isEdit) {
      this.$scope.badge.Background = this.$scope.badge.background;
      this.badgeService.updateBadge(this.$scope.badge).then(
        () => {
          this.$scope.indicators.saving = false;
          this.$state.go("^.^");
        },
        (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "saving" })
      );
    } else {
      this.badgeService.createBadge(this.$scope.badge).then(
        () => {
          this.$scope.indicators.saving = false;
          this.$state.go("^.^");
        },
        (err) => this.uiErrorHandlingService.handleIndicator(err, { indicator: "saving" })
      );
    }
  };
}
